/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-confusing-arrow */
import PropTypes from 'prop-types';
import React from 'react';

import { ButtonCancel, ButtonPrimary, ButtonSecondary } from './styles';

const Button = ({ type, children, ...props }) =>
  type === 'primary' ? (
    <ButtonPrimary {...props}>{children}</ButtonPrimary>
  ) : type === 'secondary' ? (
    <ButtonSecondary {...props}>{children}</ButtonSecondary>
  ) : (
    type === 'cancel' && <ButtonCancel {...props}>{children}</ButtonCancel>
  );

Button.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any,
};

Button.defaultProps = {
  type: 'primary',
  children: null,
};

export default Button;
